/**
 * Created by suhel on 4/26/17.
 */
import React, { Component, PropTypes } from 'react';
import { inject, observer } from 'mobx-react';
import { observable, toJS, action, autorun } from 'mobx';
import Form, { FormBody } from "../Form";
// import HierTable from '../HierTable';
import * as api from '../../actions/api';
import { token } from "../../libs/localStorage";
import Spinner from "../Spinner";

@inject('folderStore', 'stationPermissionStore', 'rolePermissionStore', 'userStore')
@observer
class StationPermissionList extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  };

  columns = [
    // { key: 'id', label: 'ID' },
    { key: 'name', label: 'Name', colClassName: 'level-2-indent-left' },
    { key: 'selected', label: 'Permission Grant' },
  ];
  @observable data = [];
  @observable checkAll = false;
  @observable forCheckBox = [];
  @observable searchFilter = '';
  @observable savedPermissions = [];
  @observable fetchingPermission = false;

  dispose;

  componentWillMount() {
    const { folderStore, params: { id } } = this.props;
    this.dispose = autorun(() => {
      if (folderStore.items.length > 0) {
        // console.log('dispose', new Date());
        this.fetchingPermission = true;
        this.setCheckboxSelected(folderStore.items);
        this.flattenTableData(folderStore.items);
        this.makeRequest(id);
        if (typeof this.dispose === 'function') this.dispose();
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    this.makeRequest(nextProps.params.id);
  }

  @action onChangeSearchText = e => {
    this.checkAll = false;
    this.searchFilter = e.target.value.toLowerCase()
  };

  @action onChangeCheck(index) {
    // let selectedItem = this.data[index];
    // console.log('onChangeCheck', new Date());
    this.forCheckBox[index].selected = !this.forCheckBox[index].selected;
    // console.log('onChangeCheck2', new Date());

    // check all children options
    // if (selectedItem.level == 1) {
    //   for (let i = index + 1; i < this.data.length; i++) {
    //     if (this.data[i].level == 1) {
    //       break;
    //     }
    //     this.forCheckBox[i].selected = this.forCheckBox[index].selected;
    //   }
    // }
  }

  @action onCheckAll = e => {
    this.checkAll = e.target.checked;

    const filteredStations = this.data.filter(item => item.level === 2 && (item.name.toLowerCase().includes(this.searchFilter) || item.tags.find(tag => tag.name.toLowerCase().includes(this.searchFilter))));

    if (this.searchFilter === '') {
      this.forCheckBox.forEach(item => {
        item.selected = e.target.checked
      });
    } else {
      this.forCheckBox.filter(i => filteredStations.find(di => di.id === i.id)).forEach(item => {
        item.selected = e.target.checked
      });
    }
  };

  @action setCheckboxSelected = (folders) => {
    setImmediate(() => {
      // console.log('setCheckboxSelected', new Date());
      this.forCheckBox = [];
      let forCheckBox = [];
      folders.forEach(folder => {
        forCheckBox.push({
          level: 1,
          id: folder.id,
          folderId: folder.id,
          selected: false,
          expanded: false
        });
        folder.stations.forEach(station => {
          forCheckBox.push({
            level: 2,
            id: station.id,
            stationId: station.id,
            selected: false,
            parentId: folder.id,
          })
        })
      });
      this.forCheckBox = forCheckBox;
      // console.log('setCheckboxSelected1', new Date());
      // this.flattenTableData(folders);
    })
  };

  flattenTableData = (folders) => {
    setImmediate(() => {
      // console.log('flattenTableData', new Date());
      this.data = [];
      let data = [];
      folders.forEach(folder => {
        let cbFolder = this.forCheckBox.find(cbitem => +cbitem.folderId === +folder.id);
        data.push({
          type: 'FOLDER',
          level: 1,
          key: data.length,
          id: folder.id,
          name: folder.name,
          selected: <input type="checkbox" onChange={this.onChangeCheck.bind(this, data.length)}
            value={cbFolder.selected}
            checked={cbFolder.selected} />,
          data: {
            id: folder.id,
            name: folder.name,
            selected: <input type="checkbox" onChange={this.onChangeCheck.bind(this, data.length)}
              value={cbFolder.selected}
              checked={cbFolder.selected} />
          }
        });
        if (folder.stations && folder.stations.length) folder.stations.forEach(station => {
          let cbStation = this.forCheckBox.find(cbitem => +cbitem.stationId === +station.id);
          data.push({
            type: 'STATION',
            level: 2,
            key: data.length,
            id: station.id,
            name: station.name,
            tags: station.tags,
            selected: <input type="checkbox" onChange={this.onChangeCheck.bind(this, data.length)}
              value={cbStation.selected}
              checked={cbStation.selected} />,
            parent_id: folder.id,
            data: {
              id: station.id,
              name: station.name,
              tags: station.tags,
              selected: <input type="checkbox" onChange={this.onChangeCheck.bind(this, data.length)}
                value={cbStation.selected}
                checked={cbStation.selected} />
            }
          })
        })
      });
      this.data = data;
      // console.log('flattenTableData1', new Date());
    });
  };

  makeRequest = (id) => {
    setImmediate(() => {
      // console.log('makeRequest', new Date());
      api.userPermission.station.fetchById(id).then(({ stations, folders }) => {

        this.savedPermissions = { stations, folders };
        this.forCheckBox.map(fcb => {
          fcb.selected = false;
        });
        stations && stations.length && stations.map(perm => {
          let station = this.forCheckBox.find(cb => cb.stationId == perm.station_id)
          if (station) station.selected = true;
        });

        folders && folders.length && folders.map(perm => {
          let folder = this.forCheckBox.find(cb => cb.folderId == perm.folder_id)
          if (folder) folder.selected = true;
        });

        // this.forCheckBox.filter(cb => cb.level == 1)
        //   .map((cbParent) => {
        //     let allChildChecked = true;
        //     let cbChilds = this.forCheckBox.filter(cbChild => cbChild.parentId && cbChild.parentId == cbParent.id);
        //     if (cbChilds.length > 0) {
        //       cbChilds.map(cbChild => {
        //         if (allChildChecked && !cbChild.selected) allChildChecked = cbChild.selected;
        //       });
        //     } else {
        //       allChildChecked = false;
        //     }
        //     cbParent.selected = allChildChecked;
        //   });
        this.fetchingPermission = false;
        // console.log('makeRequest1', new Date());
      })
    });
  };

  handleSaveUserStationPermission = () => {
    const { params: { id }, stationPermissionStore } = this.props;
    const { notify, router } = this.context;

    let json = {
      user_id: id,
      folders: [],
      stations: []
    };

    this.forCheckBox.map(cb => {
      if (+cb.level === 1 && cb.selected) {
        json.folders.push({
          folder_id: cb.folderId
        });
      } else if (+cb.level === 2 && cb.selected && !this.forCheckBox.find(item => +item.level === 1 && +item.id === cb.parentId).selected) {
        json.stations.push({
          station_id: cb.stationId
        });
      }
    });
    api.userPermission.station.create(json).then(res => {
      if (+id === +token.getDecoded().id) stationPermissionStore.items = json;
      notify.success(res);
      router.push('/user');
    }).catch(notify.error);
  };

  render() {
    const { params: { id }, rolePermissionStore, folderStore } = this.props;

    let modifyPermission = rolePermissionStore.validateRole('modify permission');

    return (
      <div style={{ height: '70vh', overflowY: 'auto', width: '70vw' }}>
        {(folderStore.isLoading || rolePermissionStore.isLoading || this.fetchingPermission) ? <Spinner /> :
          <div>
            <Form>
              <FormBody>
                <div className='formInput'><input placeholder="Search" onChange={this.onChangeSearchText} style={{ margin: 10 }} /></div>
              </FormBody>
            </Form>
            <div className="DataTable">
              <table>
                {/*<caption>{user.name} - Station Permissions</caption>*/}
                <thead>
                  <tr>
                    {this.searchFilter === '' && <th>{''}</th>}
                    <th>Name</th>
                    <th>Permission Grant <input type="checkbox" style={{ marginLeft: 10 }} disabled={!modifyPermission} checked={this.checkAll} onChange={this.onCheckAll} /></th>
                  </tr>
                </thead>
                <tbody>
                  {this.searchFilter === '' ? this.data.map((cb, index) => {
                    // if(index === 0) console.log('start', new Date());
                    // if(index === this.data.length - 1) console.log('end', new Date());
                    let prevExpanded, caretDown = false, caretRight = false, checked = false, display = +cb.level === 1;
                    let folderCBItem = this.forCheckBox.find(x => +x.folderId === +cb.id),
                      parentCBItem = this.forCheckBox.find(fcb => +fcb.folderId === +cb.parent_id),
                      stationCBItem = this.forCheckBox.find(cbitem => +cbitem.stationId === cb.id);

                    if (+cb.level === 1) {
                      prevExpanded = folderCBItem.expanded;
                      caretDown = +cb.level === 1 && prevExpanded;
                      caretRight = +cb.level === 1 && !prevExpanded;
                      checked = folderCBItem.selected;
                    } else if (+cb.level === 2) {
                      checked = stationCBItem.selected;
                      display = parentCBItem.expanded && !parentCBItem.selected;
                    }
                    const onClickExpandCollapse = () => {
                      if (+cb.level === 1 && !folderCBItem.selected) folderCBItem.expanded = !prevExpanded;
                    };

                    if (!display) {
                      return;
                    }

                    return (
                      <tr className={`level-${cb.level}`} key={cb.key}>
                        <td className="caret" onClick={onClickExpandCollapse}>
                          {caretDown && <i className="fa fa-caret-down" aria-hidden="true" />}
                          {caretRight && <i className="fa fa-caret-right" aria-hidden="true" />}
                        </td>
                        <td onClick={onClickExpandCollapse}>{cb.name || cb.id}</td>
                        <td>
                          <input type="checkbox"
                            disabled={!modifyPermission}
                            onChange={this.onChangeCheck.bind(this, index)}
                            value={checked}
                            checked={checked} />
                        </td>
                      </tr>
                    );
                  }) : this.data.filter(item => item.level === 2 && (item.name.toLowerCase().includes(this.searchFilter) || (item.tags || []).find(tag => tag.name.toLowerCase().includes(this.searchFilter)))).map(cb => {

                    const stationCBItem = this.forCheckBox.find(cbitem => +cbitem.stationId === cb.id);
                    const checked = stationCBItem.selected;

                    return (
                      <tr className={`level-${cb.level}`} key={cb.key}>
                        <td>{cb.name || cb.id}</td>
                        <td>
                          <input type="checkbox" disabled={!modifyPermission} onChange={this.onChangeCheck.bind(this, this.data.indexOf(cb))} value={checked} checked={checked} />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {modifyPermission && <button className="button" onClick={this.handleSaveUserStationPermission}>Save</button>}
            </div>
          </div>}
      </div>
      /*<HierTable caption={this.props.user.name} data={this.data} columns={this.columns}/>*/

    )
  };

}

export default StationPermissionList;


// WEBPACK FOOTER //
// ./src/components/Permission/StationPermissionList.js